<!-- 云南邮储白名单H5项目 -->
<template>
  <div
    :class="{
      'page-100vh': page100vh,
      'yunnan-postal-white-list': true,
    }"
  >
    <div class="top"></div>
    <van-skeleton v-if="imgLoading" title :row="3" />
    <div v-else>
      <div class="input-box">
        <div class="title">请输入申请信用卡时填写的手机号</div>
        <van-form @submit="alipayAcciuntConfirm">
          <van-cell-group inset>
            <van-field
              v-model="formData.phone"
              label=""
              placeholder="请输入手机号"
              label-width="0px"
              maxlength="11"
              input-align="center"
              :rules="[
                { validator: validatorPhone, message: '请填写正确的手机号' },
              ]"
            />
          </van-cell-group>
          <div class="btn-row">
            <van-button
              class="btn"
              round
              block
              color="#000"
              :loading="btnDisabled"
              native-type="submit"
            >
              确定
            </van-button>
          </div>
        </van-form>
        <div class="count-row">
          <img
            src="@/assets/imgs/yunnanPostalWhiteList/count.png"
            class="icon"
            alt=""
          />
          <span>剩余名额: </span>
          <span class="count">{{ receiveCount }}</span>
        </div>
      </div>

      <!-- <van-button
        class="btn"
        round
        block
        color="#000"
        :loading="btnDisabled"
        @click="dayin"
      >
        dayin
      </van-button> -->

      <div class="active-object-box">
        <div class="time-row">
          <img
            class="title"
            src="@/assets/imgs/yunnanPostalWhiteList/time.png"
            alt=""
          />
          <div class="des">2025年4月15日00:00:00至2025年12月31日23:59:59</div>
        </div>
        <div class="content">
          <img
            class="title"
            src="@/assets/imgs/yunnanPostalWhiteList/object.png"
            alt=""
          />
          <div class="des">
            邮储银行云南分行自2025年1月1日起信用卡首刷新客户。
          </div>
        </div>
      </div>
      <div class="active-content-box">
        <img
          class="title"
          src="@/assets/imgs/yunnanPostalWhiteList/content.png"
          alt=""
        />
        <div class="content">
          <!-- <span class="stress1"></span>
        <span class="stress2"></span> -->
          <div class="des">
            邮储银行云南省分行信用卡主卡（分享卡、教育分期卡、悦享分期卡、悦享家装分期卡除外）的首刷新客户，自首刷之日起<span
              class="stress1"
              >31天后</span
            >，登录邮储信用卡信用卡app领取1张<span class="stress1"
              >50元支付宝红包，订单金额满260
              元可用，红包有效期自领取之日起7天。</span
            >活动期间， 每个客户仅可领取<span class="stress1">1</span
            >次，活动名额<span class="stress1">2.5万</span>个，
            <span class="stress2">名额有限，先到先得。</span>
          </div>
        </div>
      </div>
      <div class="rule-box">
        <img
          class="title"
          src="@/assets/imgs/yunnanPostalWhiteList/rule.png"
          alt=""
        />
        <div class="des">
          {{
            `1.本活动仅限邮储银行云南省分行信用卡主卡（分享卡、教育分期卡、悦享分期卡、悦享家装分期卡产品除外）的首刷新客户参与本活动，附属卡不参与本活动。
        \n2.同一账户、同一身份证号、同一银行卡号、同一手机号码、同一设备等任意一项或者多项存在相同均被认定为同一用户。
        \n3.优惠券总名额分别2.5万个，数量有限，先购先得；活动参与路径：邮储信用卡APP-活动礼遇-云南分行2025年首刷新客礼，剩余名额可在活动领取页面实时查询。
        \n4.支付宝50元红包请在领取当日起7个自然日内使用，过期作废，不予补发；
        \n5.达标统计时间区间：2025年1月1日起至2025年12月31日，红包领取的截止日期：2025年12月31日23:59:59；
        \n6.交易若发生退款（含部分退款）、冲正，退款金额以用户实际支付金额为准，用户可享的优惠次数不再恢复。
        \n7.本活动优惠券为支付宝通用红包，50元支付宝红包单笔消费满260元可用，自领取之日起后7天内有效，逾期失效不补发。
        \n8.本活动优惠券使用时，需在支付宝APP绑定邮储银行信用卡，并通过支付宝选择邮储银行信用卡付款。
        \n9.支付宝红包的适用范围以支付宝APP展示为准；
        \n10.支付宝红包在支付宝APP-首页-卡包查看；
        \n11.法律法规允许范围内，如出现不可抗力情形的，邮储银行云南省分行保留调整、暂停、终止活动的权力，并经相关渠道(如邮储银行云南分行微信公众号、短信、对账单、邮储信用卡APP或营业网点等）公告后生效。
        \n12.本活动其他未尽事宜同时受最新版《中国邮政储蓄银行信用卡（个人卡）章程》、《中国邮政储蓄银行信用卡（个人卡）领用合约》及其它相关文件约束，章程和领用合约详见邮储银行官网（网址：ww-w.psbc.com)
        \n13.如持卡人对于礼品有任何疑问或投诉，可拨打易点生活客服电话：4006627299。如涉及卡片使用问题或投诉可联系邮储信用卡客服电话4008895580。`
          }}

          <img
            src="@/assets/imgs/yunnanPostalWhiteList/bottom_bg.png"
            alt=""
            class="pic"
          />
        </div>
      </div>
    </div>

    <ResultPopup ref="resultPopupRef" @result-popup-close="resultPopupClose" />
    <AccountSelectPopup
      ref="accountSelectPopupRef"
      @receive="receive"
      @account-select-popup-close="accountSelectPopupClose"
    />
  </div>
</template>

<script>
import ResultPopup from './components/ResultPopup.vue'
import AccountSelectPopup from './components/AccountSelectPopup.vue'
import {
  login,
  getCustomerInfo,
  getReceiveCount,
  receive,
} from '@/api/yunnanPsbc'
import hex_md5 from 'js-md5'
export default {
  name: 'Play',
  components: { ResultPopup, AccountSelectPopup, },
  computed: {},
  data() {
    return {
      title: '易点生活-权益营销活动',
      // 校验函数返回 true 表示校验通过，false 表示不通过
      validatorPhone(val) {
        return /1\d{10}/.test(val);
      },
      formData: {
        phone: undefined,
      },
      btnDisabled: false,
      thirdCode: '9QYBeSsBcAHA/6CWYCRj1w2VHq+kGcfpBvhU+750jwLlmND2/7CRwdMPHWeiWNBtN9G+0hB77u6BxIn10f5l+oQoPg4P9orxTizJKVcOAaA=',
      userInfo: {
        customerId: undefined, // 邮储客户编号
        flag: undefined, // 满足条件标识 0不满足 1满足
        receiveStatus: undefined, // 领取状态 0未领取 1已领取
        activityStatus: undefined, // 活动状态 θ不可参与 1可参与
      },
      receiveCount: 0, // 领取次数
      loading: true, // 获取第三方code且获取用户信息成功
      page100vh: false,
      imgLoading: true,
    }
  },
  mounted() {
    //首页回退禁用
    // history.pushState(null, null, document.URL)
    // window.addEventListener('popstate', this.popstatehandle)
    document.title = this.title
    this.preFetchImg()

    // 方案，code会过期并且只能使用一次
    this.getThirdAuthorizationcode() // 获取第三方code, 并登录
    this.getReceiveCount() // 获取用户领取次数

    // if (sessionStorage.getItem('yunnanPsbcToken')) {
    //   let yunnanPsbcCode = sessionStorage.getItem('yunnanPsbcCode')
    //   if (yunnanPsbcCode) {
    //     this.thirdCode = yunnanPsbcCode // code可以重复使用吗
    //   }
    //   this.getUserInfo()
    //   this.getReceiveCount()
    // } else {
    //   // this.login()
    //   this.getThirdAuthorizationcode()
    // }

    const _this = this



    // 设置监听获取第三方code方法
    window.handleAuthorization = function ({ code }) {
      console.log('handleAuthorization获取到code===', code);
      if (code) {
        // 缓存code
        sessionStorage.setItem('yunnanPsbcCode', code)
        _this.thirdCode = code
        _this.login()
      } else {
        _this.openMsgPopup({
          icon: 2,
          title: '系统繁忙，请退出后重进',
          message: '',
        })
      }

    }
  },
  methods: {
    dayin() {
      this.openMsgPopup({
        icon: 1,
        title: '不在活动时间内',
        message: '',
      })
    },
    // 获取银行的第三方
    getThirdAuthorizationcode() {
      // 参数必须为json对象
      var appId = 'ynfhsshdydsh'; // 联系信用卡APP后端老师获取
      var time = Date.now().toString(); // 时间戳
      var secret = '82B7A0EBD16F444EA3DA9D5F00162E40'; // 联系信用卡APP后端老师获取
      var signBefore = appId + time + secret;
      var sign = hex_md5(signBefore);// 普通md5加密，需引入md5.js
      var params = {
        appId: appId,
        sign: sign,
        time: time,
        tran_code: '0311', // 联系信用卡APP后端老师获取
        fn: 'handleAuthorization', // 回调函数名称,此回调函数名称由三方页面自定义，客户端获取唯一标识code后通过全局调用该回调函数回传给三方。注意：函数名称为字符串格式，非函数引用！
        needBind: "1"// 默认不需要绑卡，传'1'表示需要绑卡
      };
      // eslint-disable-next-line no-undef
      Fw.device.api.getNewAuthorization(params); // 调用客户端插件
      // eslint-disable-next-line no-undef
      // console.log(Fw, 'Fw===');
      //  console.log(params, 'params===');
    },
    // 登录
    login() {
      login({ thirdCode: this.thirdCode }).then(res => {
        this.userInfo = res.data
        const { token, } = this.userInfo
        if (token) {
          sessionStorage.setItem('yunnanPsbcToken', token)
        }
        this.qualification() // 资格判断
        this.loading = false
      }).catch(res => {
        this.openMsgPopup({
          icon: 1,
          title: res.message,
          message: '',
        })
      })
    },
    // 获取用户信息
    getUserInfo() {
      getCustomerInfo({ thirdCode: this.thirdCode }).then(res => {
        this.userInfo = res.data
        const { token, } = this.userInfo
        // if (token) {
        //   sessionStorage.setItem('yunnanPsbcToken', token)
        // }
        this.qualification() // 资格判断
      }).catch(res => {
        this.openMsgPopup({
          icon: 1,
          title: res.message,
          message: '',
        })
      })
    },
    // 获取已领取数量
    getReceiveCount() {
      getReceiveCount({}).then(res => {
        this.receiveCount = res.data
      })
    },
    // 支付宝账号确认
    alipayAcciuntConfirm() {
      if (this.loading) return this.$toast('信息初始化中，请稍后')
      if (!this.qualification()) return
      this.page100vh = true
      this.$refs.accountSelectPopupRef.open(this.formData.phone)
    },
    // 资格判断
    qualification() {
      // return true
      const { flag, receiveStatus, activityStatus } = this.userInfo
      if (activityStatus === 0) { // 活动状态 θ不可参与 1可参与
        this.openMsgPopup({
          icon: 1,
          title: '不在活动时间内',
          message: '',
        })
        return false
      }
      if (receiveStatus === 1) { // 领取状态 0未领取 1已领取
        this.openMsgPopup({
          icon: 1,
          title: '您已享受过权益',
          message: '无法再次领取!',
        })
        return false
      }
      //  flag 类型确认
      if (flag === '0') { // 满足条件标识 0不满足 1满足
        this.openMsgPopup({
          icon: 1,
          title: '暂不符合领取资格',
          message: '',
        })
        return false
      }
      return true
    },
    receive(alipayAccount, callback) {
      receive({
        alipayAccount: alipayAccount,
      }).then(() => {
        callback()
        this.openMsgPopup({
          icon: 0,
          title: '领取成功!',
          message: '请前往支付宝APP-首页-卡包查看',
        })
        // this.getUserInfo()
        this.userInfo.receiveStatus = 1 // 已领取
      }).catch((res) => {
        callback()
        this.openMsgPopup({
          icon: 2,
          title: '领取失败!',
          message: res.message,
        })
      })
    },
    // 信息弹窗
    openMsgPopup({ icon = 0, title = '', message = '' }) {
      this.$refs.resultPopupRef.iconKey = icon // 0:成功，1：警告，2：错误
      this.$refs.resultPopupRef.title = title
      this.$refs.resultPopupRef.message = message
      this.$refs.resultPopupRef.setShow(true)
      this.page100vh = true
    },
    popstatehandle() {
      history.pushState(null, null, document.URL)
      if (this.isWechat()) {
        // eslint-disable-next-line
        wx.closeWindow();
        //微信
      } else {
        window.close()
      }
    },
    isWechat() {
      return /MicroMessenger/i.test(window.navigator.userAgent);
    },
    // 页面图片预先加载
    preFetchImg() {
      return new Promise((resolve, reject) => {
        let imgs = [
          require("@/assets/imgs/yunnanPostalWhiteList/card.png"),
          require("@/assets/imgs/yunnanPostalWhiteList/card1.png"),
          require("@/assets/imgs/yunnanPostalWhiteList/card2.png"),
          require("@/assets/imgs/yunnanPostalWhiteList/dialog-bg.png"),
          require("@/assets/imgs/yunnanPostalWhiteList/dialog-bg1.png"),
        ]
        let sum = imgs.length
        let num = 0
        for (let img of imgs) {
          let image = new Image()
          image.src = img
          image.onload = () => {
            // 图片加载完整
            num++
            if (sum === num) {
              resolve()
              this.imgLoading = false
            }
          }
        }
      })
    },
    accountSelectPopupClose() {
      this.page100vh = false
    },
    resultPopupClose() {
      this.page100vh = false
    },
  }
}
</script>

<style lang="less" scoped>
.yunnan-postal-white-list {
  width: 100%;
  min-height: 100vh;
  // padding-bottom: 40px;
  box-sizing: border-box;
  background: url("../../../assets/imgs/yunnanPostalWhiteList/cover.jpg")
    no-repeat #327044;
  background-size: 100% auto;
  text-align: center;
  .top {
    width: 100%;
    height: 400px;
    // height: 100px;
  }
  .input-box {
    width: 351px;
    height: 274px;
    margin: auto;
    background: url("../../../assets/imgs/yunnanPostalWhiteList/card.png")
      no-repeat;
    background-size: contain;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .title {
      font-size: 14px;
      color: #000000;
      margin-bottom: 24px;
    }
    /deep/ .van-field {
      height: 100px;
    }
    /deep/ .van-field__body {
      width: 100%;
      height: 55px;
      background: #ffffff;
      border-radius: 28px;
      border: 1px solid #cde1d2;
    }
    .btn-row {
      text-align: center;
      .btn {
        margin: 0px auto 22px auto;
        width: 310px;
        height: 52px;
        font-weight: 600;
        font-size: 20px;
      }
    }
    .count-row {
      font-size: 12px;
      color: #000000;
      .icon {
        width: 12px;
        margin-right: 10px;
      }
      .count {
        color: #d72622;
      }
    }
  }
  // 时间对象
  .active-object-box {
    padding: 30px 20px 0 20px;
    width: 351px;
    height: 241px;
    box-sizing: border-box;
    margin: auto;
    background: url("../../../assets/imgs/yunnanPostalWhiteList/card2.png")
      no-repeat;
    background-size: contain;
    text-align: left;
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-size: 12px;
    .title {
      width: 84px;
    }
    .des {
      margin: 8px 0;
      line-height: 1.8;
      font-size: 13px;
      color: #000000;
    }
    .time-row {
      padding-left: 15px;
    }
    .content {
      padding: 12px 15px 0px 15px;
      width: 317px;
      box-sizing: border-box;
      background: #eff7e3;
      border-radius: 15px;
      text-align: justify;
    }
  }
  // 内容
  .active-content-box {
    padding: 20px 20px 0 20px;
    width: 351px;
    height: 288px;
    box-sizing: border-box;
    margin: auto;
    background: url("../../../assets/imgs/yunnanPostalWhiteList/card1.png")
      no-repeat;
    background-size: contain;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: left;
    font-size: 12px;
    .title {
      margin-top: 10px;
      width: 84px;
      // height: 19px;
    }
    .des {
      margin: 15px 0;
      line-height: 1.8;
      font-size: 13px;
      color: #000000;
    }
    .content {
      margin-top: 10px;
      padding: 0 15px;
      width: 317px;
      box-sizing: border-box;
      background: #eff7e3;
      border-radius: 15px;
      text-align: justify;
    }
    .stress1 {
      color: #d72622;
      font-weight: 600;
    }
    .stress2 {
      font-weight: 600;
    }
  }
  .rule-box {
    .title {
      margin: 25px 0 18px 0;
      width: 170px;
      // height: 26px;
    }
    .des {
      padding: 0 15px 50px 20px;
      font-size: 12px;
      color: #caf1ad;
      line-height: 1.5;
      text-align: left;
      text-align: justify;
      white-space: pre-line;
      position: relative;
      .pic {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 217px;
      }
    }
  }
}
.page-100vh {
  height: 100vh;
  overflow: hidden;
}
</style>
